var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.items.length
    ? _c("div", { staticClass: "cancellations-container" }, [
        _c(
          "div",
          { staticClass: "cancellations" },
          [
            _vm._m(0),
            _vm._v(" "),
            !_vm.upcomingFlights.length
              ? _c("div", { staticClass: "italic" }, [
                  _vm._v("No upcoming "),
                  _c("span", { staticClass: "hide-sm" }, [_vm._v("flight ")]),
                  _vm._v("cancellations")
                ])
              : _vm._l(_vm.upcomingFlights, function(group) {
                  return _c("cancellation-item", {
                    key: group.group,
                    attrs: { item: group }
                  })
                })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "cancellations" },
          [
            _vm._m(1),
            _vm._v(" "),
            !_vm.pastFlights.length
              ? _c("div", { staticClass: "italic" }, [
                  _vm._v("No past "),
                  _c("span", { staticClass: "hide-sm" }, [_vm._v("flight ")]),
                  _vm._v("cancellations")
                ])
              : _vm._l(_vm.pastFlights, function(group) {
                  return _c("cancellation-item", {
                    key: group.group,
                    attrs: { item: group }
                  })
                })
          ],
          2
        )
      ])
    : _c("div", [_vm._v("\n    There are currently no cancellations.\n")])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cancellations-header" }, [
      _vm._v("\n            Upcoming"),
      _c("span", { staticClass: "hide-sm hide-md" }, [_vm._v(" Flight")]),
      _c("span", { staticClass: "hide-sm" }, [_vm._v(" Cancellations")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cancellations-header" }, [
      _vm._v("\n            Past"),
      _c("span", { staticClass: "hide-sm hide-md" }, [_vm._v(" Flight")]),
      _c("span", { staticClass: "hide-sm" }, [_vm._v(" Cancellations")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-54ac7c9f", { render: render, staticRenderFns: staticRenderFns })
  }
}